// frontend/src/config/userGuideLanguages.js
//
// Language registry for the in-app User Guide.
//
// The workforce is predominantly Bangladeshi, Indian and Burmese (see
// scripts/_diag_worker_nationality.py), so the guide is being made available
// in those native languages on top of the English default.
//
// `ready: false` means the translation has not been added/reviewed yet — the
// language shows in the switcher as "coming soon" and is not selectable, so
// nothing renders as broken English-in-disguise. Flip to `ready: true` once
// the locale's strings exist in userGuideTranslations.js and a native speaker
// has reviewed them.

export const DEFAULT_GUIDE_LANG = 'en';

export const GUIDE_LANGUAGES = [
  { code: 'en', label: 'English',  nativeLabel: 'English',  ready: true  },
  { code: 'bn', label: 'Bengali',  nativeLabel: 'বাংলা',     ready: true  },
  { code: 'ta', label: 'Tamil',    nativeLabel: 'தமிழ்',     ready: true  },
  { code: 'my', label: 'Burmese',  nativeLabel: 'မြန်မာ',    ready: true  },
];

// Suggested guide language(s) per canonical nationality (lower-cased).
export const NATIONALITY_TO_GUIDE_LANGS = {
  bangladeshi: ['bn'],
  bangladesh: ['bn'],
  indian: ['ta'],
  india: ['ta'],
  burmese: ['my'],
  myanmar: ['my'],
  burma: ['my'],
};

export const isLanguageReady = (code) =>
  GUIDE_LANGUAGES.some((l) => l.code === code && l.ready);

export const getReadyLanguages = () => GUIDE_LANGUAGES.filter((l) => l.ready);
